import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ProxyUser from "pages/ProxyUser";
import { checkPermission } from "utils/HelperFunctions";
import { checkUserModuleComponentEnabled } from "utils/Modules";
import SignUpCover from "../pages/authentication/sign-up/cover";
import SignInCover from "../pages/authentication/sign-in/cover";
import ForgotPassword from "../pages/authentication/forgot-password";
import ChangePassword from "../pages/authentication/change-password";
import InvalidInvitation from "../pages/authentication/invalid-invitation";
import EmailVerification from "../pages/authentication/email-verification";
import Workspace from "../pages/authentication/workspace";
import SSOTokenFetch from "../pages/authentication/sso-token-fetch";
import { routes } from "../routes";
import PageNotFound from "../pages/404/404";

function PublicRoutings() {
  const routers = [
    {
      name: "Sign-In",
      key: "sign-in",
      route: "/sign-in",
      component: <SignInCover />,
    },
    {
      name: "Forogt Password",
      key: "forgot-password",
      route: "/forgot-password",
      component: <ForgotPassword />,
    },
    {
      name: "Change Password",
      key: "change-password",
      route: "/change-password/:token",
      component: <ChangePassword title="Change Password" />,
    },
    {
      name: "Create Password",
      key: "create-password",
      route: "/create-password/:token",
      component: <ChangePassword title="Create Password" />,
    },
    {
      name: "Invalid Invitation",
      key: "invalid-invitation",
      route: "/invalid-invitation",
      component: <InvalidInvitation />,
    },
    {
      name: "Sign-Up",
      key: "sign-up",
      route: "/sign-up",
      component: <SignUpCover />,
    },
    {
      name: "Email Verification",
      key: "verify-email",
      route: "/verify-email",
      component: <EmailVerification />,
    },
    {
      name: "Workspace",
      key: "workspace",
      route: "/workspace",
      component: <Workspace />,
    },
    {
      name: "Proxy Login",
      key: "proxy-login",
      route: "proxy-login",
      component: <ProxyUser />,
    },
    {
      name: "SSO token fetch",
      key: "sso-token-fetch",
      route: "sso-token-fetch/:provider",
      component: <SSOTokenFetch />,
    },
  ];
  const storeData = useSelector((state) => state.loginUser.loginUserState);
  const modules = useSelector((state) => state.modules.enabledModules);
  const user = storeData;
  const userType = storeData.type;
  const getRoutes = (allRoutes) => {
    const routings = allRoutes
      .filter((route) => {
        if (userType !== "user") {
          return true;
        }

        // Component check
        if (
          route.module_component &&
          route.module &&
          !checkUserModuleComponentEnabled(modules, route.module, route.component)
        ) {
          return false;
        }

        // Module check
        if (route.module && !checkUserModuleComponentEnabled(modules, route.module)) {
          return false;
        }

        if (!route.permissionName) {
          return true;
        }

        if (userType === "user" && Array.isArray(route.permissionName)) {
          let permissionAllowed = false;
          // eslint-disable-next-line no-restricted-syntax, no-unsafe-optional-chaining
          for (const permission of route?.permissionName) {
            if (checkPermission(permission, storeData?.userPermission)) {
              permissionAllowed = true;
              break;
            }
          }
          return permissionAllowed;
        }

        if (
          userType === "user" &&
          route.permissionName &&
          checkPermission(route.permissionName, storeData?.userPermission)
        ) {
          return true;
        }
        return false;
      })
      .map((route) => {
        const clonedRoute = { ...route };
        const collapse = [];
        if (user) {
          if (
            clonedRoute?.accessby?.includes(userType)
            //   && (route.key === "registrations" || route.key === "subscriptions" || route.key === "users")
          ) {
            // handling routing for submenu
            if (clonedRoute.type === "collapse") {
              clonedRoute.collapse.forEach((nestedRoute) => {
                if (
                  nestedRoute.accessby?.includes(userType) &&
                  userType === "user" &&
                  Array.isArray(nestedRoute.permissionName)
                ) {
                  let permissionAllowed = false;
                  // eslint-disable-next-line no-restricted-syntax, no-unsafe-optional-chaining
                  for (const permission of nestedRoute?.permissionName) {
                    if (checkPermission(permission, storeData?.userPermission)) {
                      permissionAllowed = true;
                      break;
                    }
                  }
                  if (permissionAllowed) {
                    collapse.push(nestedRoute);
                  }
                } else if (
                  (userType === "user" &&
                    nestedRoute.permissionName &&
                    checkPermission(nestedRoute.permissionName, storeData?.userPermission)) ||
                  userType !== "user" ||
                  !nestedRoute.permissionName
                ) {
                  collapse.push(nestedRoute);
                }
              });
              clonedRoute.collapse = collapse;
              return clonedRoute?.collapse?.map((_) =>
                _.accessby?.includes(userType) ? (
                  <Route exact path={_.route} element={_.component} key={_.key} />
                ) : null
              );
            }
            //   return <Route exact path={route.route} element={<>{route.component} </>} key={route.key} />;
            return (
              <Route
                exact
                path={clonedRoute.route}
                element={clonedRoute.component}
                key={clonedRoute.key}
              />
            );
          }
        }

        return null;
      });

    const removeUnmathced = routings.filter((element) => element !== null);
    return removeUnmathced;
  };
  const token = localStorage.getItem("token");
  const { pathname, search } = useLocation();

  return (
    <Routes>
      {!token &&
        routers.map((route) => (
          <Route exact path={route.route} element={route.component} key={route.key} />
        ))}
      {!token && <Route path="/*" element={<Navigate to="/sign-in" />} />}
      {user.id && !user.hasActiveWorkspaces && (
        <Route path="/home" element={<Navigate to="/workspace" />} />
      )}

      {user ? getRoutes(routes) : null}
      {token && (
        <>
          <Route
            path="/"
            element={<Navigate to={userType === "admin" ? "/registrations" : "/home"} />}
          />
          {pathname.includes("sign-in") && (
            <Route
              path="/*"
              element={
                <Navigate
                  to={
                    // eslint-disable-next-line no-nested-ternary
                    userType === "admin"
                      ? "/registrations"
                      : search
                      ? `/workspace${search}`
                      : "/home"
                  }
                />
              }
            />
          )}
          <Route path="/*" element={<Navigate to="/404" />} />
          <Route path="/404" element={<PageNotFound />} />
        </>
      )}
    </Routes>
  );
}

export default PublicRoutings;
